// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.displayImage_IqlC7 { 
  flex : 0 0 auto;
  height : 100%;
  width: 100%;
  object-fit : contain;
  background : var( --color-white );
}

.dialogBody_uAsXR.really_GqLLF.win__OzCv {
  width : 100%;
}

.dialogArea_Uq_9G {
  height : 100%; 
  width : 100%;
}

.imageContainer_mgz9F {
  height : 160px;
  width : 160px;
  object-fit : cover;
  border-radius : 4px;
  border : 1px solid var( --color-base400 );
  position : relative;
  overflow: hidden;
}

.image_L2024 {
  width : 100%;
  height : 100%;
  object-fit: cover;
  background-color: var( --color-white );
}

.imageCheck_usshX {
  position: absolute;
  right: 8px;
  top: 8px;
}

.header_wpSBY {
  padding : var( --size-pad12 ) var( --size-padLarge );
  background-color: var( --color-base025 );
  border-top: 1px solid var( --color-base200 );
  border-bottom: 1px solid var( --color-base200 );
}

.parent_GzsAP {
  position: relative;
  width : 160px;
  height : 96px;
  border : 1px solid var( --color-base200 );
}

.child_Ke9oK.common_AVE7x {
  position: absolute;
  background-color: #000000;
  opacity: 0.5;
  color : white;
  font-size: 13px;
}

.parent_GzsAP:hover .child_Ke9oK.win__OzCv, .parent_GzsAP:focus .child_Ke9oK.win__OzCv {
  visibility: visible;
}

.child_Ke9oK.win__OzCv {
  visibility: hidden;
  font-weight: 600;
}

.child_Ke9oK.win__OzCv:hover, .child_Ke9oK.win__OzCv:focus {
  background-color: #000000;
  opacity: 0.7;
}

.left_HZyGu.win__OzCv {
  border-radius: 0 16px 16px 0;
  left : 0;
  padding : 12px 8px;
  top : calc( 50% - 21px );
}

.right_m7sNs.win__OzCv {
  border-radius: 16px 0 0 16px;
  right : 0;
  padding : 12px 8px;
  top : calc( 50% - 21px );
}

.parent_GzsAP:hover .count_gxyuZ.common_AVE7x, .parent_GzsAP:focus .count_gxyuZ.common_AVE7x {
  visibility: hidden;
}

.count_gxyuZ.common_AVE7x {
  right : 4px;
  bottom : 4px;
  padding : 4px 8px;
  border-radius : 8px
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/attributes/image/imageList/resourceImage/ImageListEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,oDAAoD;EACpD,wCAAwC;EACxC,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;AACF","sourcesContent":[".displayImage { \n  flex : 0 0 auto;\n  height : 100%;\n  width: 100%;\n  object-fit : contain;\n  background : var( --color-white );\n}\n\n.dialogBody.really.win {\n  width : 100%;\n}\n\n.dialogArea {\n  height : 100%; \n  width : 100%;\n}\n\n.imageContainer {\n  height : 160px;\n  width : 160px;\n  object-fit : cover;\n  border-radius : 4px;\n  border : 1px solid var( --color-base400 );\n  position : relative;\n  overflow: hidden;\n}\n\n.image {\n  width : 100%;\n  height : 100%;\n  object-fit: cover;\n  background-color: var( --color-white );\n}\n\n.imageCheck {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n}\n\n.header {\n  padding : var( --size-pad12 ) var( --size-padLarge );\n  background-color: var( --color-base025 );\n  border-top: 1px solid var( --color-base200 );\n  border-bottom: 1px solid var( --color-base200 );\n}\n\n.parent {\n  position: relative;\n  width : 160px;\n  height : 96px;\n  border : 1px solid var( --color-base200 );\n}\n\n.child.common {\n  position: absolute;\n  background-color: #000000;\n  opacity: 0.5;\n  color : white;\n  font-size: 13px;\n}\n\n.parent:hover .child.win, .parent:focus .child.win {\n  visibility: visible;\n}\n\n.child.win {\n  visibility: hidden;\n  font-weight: 600;\n}\n\n.child.win:hover, .child.win:focus {\n  background-color: #000000;\n  opacity: 0.7;\n}\n\n.left.win {\n  border-radius: 0 16px 16px 0;\n  left : 0;\n  padding : 12px 8px;\n  top : calc( 50% - 21px );\n}\n\n.right.win {\n  border-radius: 16px 0 0 16px;\n  right : 0;\n  padding : 12px 8px;\n  top : calc( 50% - 21px );\n}\n\n.parent:hover .count.common, .parent:focus .count.common {\n  visibility: hidden;\n}\n\n.count.common {\n  right : 4px;\n  bottom : 4px;\n  padding : 4px 8px;\n  border-radius : 8px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayImage": `displayImage_IqlC7`,
	"dialogBody": `dialogBody_uAsXR`,
	"really": `really_GqLLF`,
	"win": `win__OzCv`,
	"dialogArea": `dialogArea_Uq_9G`,
	"imageContainer": `imageContainer_mgz9F`,
	"image": `image_L2024`,
	"imageCheck": `imageCheck_usshX`,
	"header": `header_wpSBY`,
	"parent": `parent_GzsAP`,
	"child": `child_Ke9oK`,
	"common": `common_AVE7x`,
	"left": `left_HZyGu`,
	"right": `right_m7sNs`,
	"count": `count_gxyuZ`
};
export default ___CSS_LOADER_EXPORT___;
